import styled from 'styled-components';

type ContainerProps = {
	cursor: string;
};

type TooltipProps = {
	position: { x: number; y: number };
	visible: boolean;
};

export const Container = styled.div<ContainerProps>`
	cursor: ${({ cursor }) => cursor};
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const Tooltip = styled.div<TooltipProps>`
	position: fixed;
	width: fit-content;
	background-color: #414d5c;
	opacity: 0.9;
	color: #fff;
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	top: ${({ position }) => position.y + 30}px;
	left: ${({ position }) => position.x - 75}px;
	z-index: 999;
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

	&::before {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-bottom: 6px solid #414d5c;
		bottom: 100%;
		left: 50%;
		transform: translateX(-50%);
	}
`;

export const ExamsContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 230px;
	gap: 6px;
`;

export const ExamRow = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 4px 0;
`;
